import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import classNames from 'classnames';

import * as classes from './Button.module.scss';

const Button = React.forwardRef((props, ref) => {
  const { children, className, variant = 'primary', asLink, asGatsbyLink, asInput, icon, ...passedProps } = props;

  const buttonClass = classNames({
    [classes.button]: true,
    [className]: !!className,
    [classes[`variant_${variant}`]]: !!variant,
    [classes.icon]: !!icon,
    [classes[`icon_${icon}`]]: !!icon
  });

  let element = 'button';

  if (asLink) {
    element = 'a';
  } else if (asGatsbyLink) {
    element = Link;
  } else if (asInput) {
    element = 'input';
  }

  return React.createElement(
    element,
    {
      className: buttonClass,
      ...passedProps,
      ref
    },
    children
  );
});

export default Button;

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'secondary_solid', 'primary_outline']),
  asLink: PropTypes.bool,
  asGatsbyLink: PropTypes.bool,
  asInput: PropTypes.bool,
  icon: PropTypes.oneOf(['back'])
};
